import { createFileRoute } from '@tanstack/react-router';
import { OverviewPage } from '../features/overview/OverviewPage';
import { validateMonthSearch } from '../lib/months';

export const Route = createFileRoute('/overview')({
  validateSearch: validateMonthSearch,
  component: OverviewPage,
});
